const zxcvbn = require("zxcvbn");
import Cleave from "cleave.js";

let meter = document.getElementById("password-strength-meter");
let userPrimaryPhone = document.getElementById("user_primary_phone");

if (userPrimaryPhone) {
  let cleave = new Cleave("#user_primary_phone", {
    blocks: [3, 3, 4],
    delimiter: "-",
    uppercase: true
  });
}

if (meter) {
  let strength = {
    0: "Worst",
    1: "Bad",
    2: "Weak",
    3: "Good",
    4: "Strong"
  };

  let password = document.getElementById("user_password");
  let text = document.getElementById("password-strength-text");
  let suggestion = document.getElementById("password-advice");

  password.addEventListener("input", function(evt) {
    let val = password.value;
    let result = zxcvbn(val);
    let suggestionString = result.feedback.suggestions.join(" ");
    meter.value = result.score;
    if (val !== "") {
      text.innerHTML = "Password Strength: " + strength[result.score];
      suggestion.innerHTML = suggestionString;
    } else {
      text.innerHTML = "";
      suggestion.innerHTML = "";
    }
  });
}
